export const NOT_FAILED_FILE_STATUSES = [
  'available',
  'pending',
  'doc_verify_in_progress',
  'doc_verify_with_errors',
];

export const SUCCESS_STATUS = 'available';
export const INVALID_FILE_STATUS = 'invalid';
export const DELETABLE_FILE_STATUSES = [
  'available',
  'doc_verify_with_errors',
  'invalid',
];

export const LRS_DOCUMENT_TYPE = 'LRS';
